import { render, staticRenderFns } from "./produits.html?vue&type=template&id=68497d82&scoped=true&external"
import script from "./produits.js?vue&type=script&lang=js&external"
export * from "./produits.js?vue&type=script&lang=js&external"
import style0 from "./produits.scss?vue&type=style&index=0&id=68497d82&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68497d82",
  null
  
)

export default component.exports